import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { User } from 'src/graphql/generated';
import { UserService } from '../../services/user.service';
import { SearchComponent } from '../search/search.component';
import { HeaderService } from './header.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  isHeaderTopVisible: boolean = true;
  scrollPosition: number = 0;

  isMenuMobileVisible: boolean = false;
  currentUser: User;
  constructor(
    private authService: AuthService,
    private router: Router,
    private dialog: MatDialog,
    private headerService: HeaderService,
    private userService: UserService,
    private cdref: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    // console.log(this.user);

    this.headerService.getIsMenuOpen().subscribe((resp) => {
      this.isMenuMobileVisible = resp;
    });

    this.getCurrentUser();
    this.userService.currentUser$.subscribe(
      result => {
        this.currentUser = result;
        this.cdref.detectChanges();
      }
    )

  }

  get isLogedIn() {
    // console.log(this.authService.isLogedIn());
    return this.authService.isLogedIn();
  }

  getCurrentUser() {
     this.userService.fetchCurrentUser().then(
      result => {
        this.currentUser = result as User;
      }
    );
  }

  logout() {
    this.authService.logOut();
  }

  toggleSearch() {
    const dialogRef = this.dialog.open(SearchComponent, {
      // data: this.user,
      maxHeight: '90vh',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // this.course.modules.push(result);
      }
    });
  }

  @ViewChild('btnToggleNavMobile') btnToggleNavMobile!: ElementRef;
  @ViewChild('navMobileContent') navMobileContent!: ElementRef;

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    if (this.isMenuMobileVisible) {
      this.handleNavClickOutside(event);
    }
  }

  handleNavClickOutside(event: Event) {
    if (
      !this.btnToggleNavMobile.nativeElement.contains(event.target) &&
      !this.navMobileContent.nativeElement.contains(event.target)
    ) {
      this.headerService.toggleMenu();
    }
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event: Event) {
    const scrollY = window.scrollY;
    const direction = scrollY > this.scrollPosition ? 'down' : 'up';

    if (direction === 'down' && scrollY > 100) {
      this.isHeaderTopVisible = false;
    } else {
      this.isHeaderTopVisible = true;
    }

    this.scrollPosition = scrollY;
  }
}
